import { getIn } from '@/imports-files/common/common';

export function InputText(formik, fieldName) {

  if (((getIn(formik.errors, fieldName) && getIn(formik.touched, fieldName)) ||
    getIn(formik.status, fieldName) && getIn(formik.touched, fieldName))) {
    return {
      color: 'var(--default-error-color)',
    }
  }

}